import React, { useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { CircularProgress } from '@mui/material';

import { RootState } from '&store/store';
import { ChallengesWrapper } from './challenges.styled';
import Container from '../../components/container/container.component';
import Challenge from '../../components/challenge/challenge.component';
import { challengesActions } from './challenges.slice';
import { useLocation } from 'react-router-dom';

type ReduxProps = ConnectedProps<typeof connector>;

const ChallengesComponent = (props: ReduxProps) => {
	const { t } = useTranslation(['home']);
	const location = useLocation();
	const { getChallenges, loading, challenges } = props;
	const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

	const handleAccordionChange = (index: number) => {
		setExpandedIndex((prevIndex) => (prevIndex === index ? null : index));
	};

	const isPrevious = location.pathname.split('/challenges/')[1] === 'previous';
	const selectedChallenges = isPrevious
		? challenges.previous
		: challenges.current;

	useEffect(() => {
		getChallenges();
	}, []);

	return (
		<ChallengesWrapper>
			<Container>
				<div className="content">
					<h2 className="title">
						{isPrevious ? 'Previous' : 'Current'} Challenges
					</h2>
					<p className="description">
						Challenges are issues in your community or organization that are
						looking for creative ways using technology to solve. When challenges
						are submitted and accepted, we will work with the team to align
						goals and provide support with innovation and technology.
					</p>

					{loading ? (
						<div className="loading-center">
							<CircularProgress size={40} color="inherit" />
						</div>
					) : (
						selectedChallenges.length > 0 &&
						selectedChallenges?.map((item: any, index: number) => {
							return (
								<Challenge
									key={index}
									index={index}
									title={item.title}
									description={item.summary}
									themes={item.themes}
									expandedIndex={expandedIndex}
									id={item.pk}
									handleAccordionChange={handleAccordionChange}
								/>
							);
						})
					)}
				</div>
			</Container>
		</ChallengesWrapper>
	);
};

const mapStateToProps = (state: RootState) => ({
	loading: state.challenges.loading,
	status: state.challenges.status,
	challenges: state.challenges.challenges,
});

const mapDispatchToProps = {
	getChallenges: challengesActions.getChallenges,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
const ChallengesComponentRedux = connector(ChallengesComponent);

export { ChallengesComponentRedux as ChallengesComponent };
